exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\nhtml {\r\n    height: 100%;\r\n}\r\n\r\nbody {\r\n    min-height: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.loader-div {\r\n    position: fixed;\r\n    /*text-align: center;*/\r\n    top: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 3;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.loader-div span {\r\n    position: relative;\r\n    top: 45%;\r\n    left: 46%;\r\n    color: #41cccd;\r\n    font-size: 40px;\r\n    font-style: oblique;\r\n    font-weight: 400;\r\n}\r\n.slimscroll-wrapper{\r\n    display: block !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 1045
// module chunks = 1